import { SidebarHeader, SidebarTitle } from 'src/components/Sidebar';

const CalendarOptionsHeader = () => (
  <SidebarHeader className="flex items-center gap-6 p-0">
    <SidebarTitle>{`Calendar Options`}</SidebarTitle>
  </SidebarHeader>
);

export default CalendarOptionsHeader;
